export default "__VITE_ASSET__DhF1BDHf__"